import { Text } from '@/components/ui/text'
import { DataGuard } from '@components/DataGuard'
import SetupAuthor from '@components/SetupAuthor'
import dayjs from 'dayjs'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box } from 'styled-system/jsx'
import ArchivedAlert from '../../Overview/ArchivedAlert'
import { useSingle } from '../../state'
import Gallery from './Gallery'
import SpecsPanel from './SpecsPanel'

export default function Analysis() {
  const { setupQuery } = useService(useSingle)()

  return (
    <>
      <Gallery />
      <DataGuard query={setupQuery}>
        {(setup) => (
          <Box px="16px" pt="13px" pb="18px" borderTop="1px solid rgba(20, 22, 30, 0.09)">
            <ArchivedAlert />
            <Text
              fontSize="19px"
              fontWeight="700"
              lineHeight="1.28"
              letterSpacing="-.015em"
              color="#14161b"
            >
              {setup.title}
            </Text>

            <Box mt="11px">
              <SetupAuthor
                createdBy={setup.created_by}
                created_at={setup.created_at}
                avatarSize="38px"
                rankSize="18px"
                nameFontSize="14px"
                metaSlot={(
                  <Text
                    fontSize="11.5px"
                    color="#8b909b"
                    mt="3px"
                    class={css({ fontVariantNumeric: 'tabular-nums' })}
                  >
                    Published {dayjs(setup.created_at).format('DD MMM YYYY')} · Modified {dayjs(setup.updated_at).format('DD MMM YYYY')}
                  </Text>
                )}
              />
            </Box>

            <SpecsPanel setup={setup} />

            <Box
              mt="14px"
              display="flex"
              flexDirection="column"
              gap="9px"
              fontSize="13.5px"
              lineHeight="1.58"
              color="#4a4f5a"
              whiteSpace="pre-wrap"
            >
              {setup.description}
            </Box>
          </Box>
        )}
      </DataGuard>
    </>
  )
}
